import React from 'react';

import AuthPage from '../../../pages/AuthPage';

const AskForLogin = ({ page }) => {
  return (
    <div className="login-required">
      <AuthPage />
    </div>
  )
};

export default AskForLogin;



// WEBPACK FOOTER //
// ./src/components/Modules/AskForLogin/index.js